<template>
  <g>
    <path
      d="M12 0a12 12 0 1012 12A12 12 0 0012 0zM8.88 16.7H6.43V9.35h2.45zM7.66 8.35h-.02a1.28 1.28 0 11.03-2.55 1.28 1.28 0 11-.01 2.55zM17.7 16.7h-2.45v-3.94c0-1-.35-1.67-1.24-1.67a1.34 1.34 0 00-1.25.9 1.68 1.68 0 00-.08.6v4.12h-2.45s.03-6.68 0-7.37h2.44v1.04a2.43 2.43 0 012.21-1.22c1.61 0 2.82 1.05 2.82 3.31v4.23z"
      fill="currentColor"
    />
  </g>
</template>